module.exports = __webpack_public_path__ + "static/media/everdays-icon-square.964bb9a1.svg";